import {NgModule} from "@angular/core";
import {RoutesPipeDirective} from "./routes-pipe.directive";


@NgModule({
  declarations: [RoutesPipeDirective],
  exports: [RoutesPipeDirective],
})
export class RoutesPipeModule {}
